import type { FC } from "react";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { Button } from "@similarweb/ui-components";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import {
    CUSTOM_NOT_FOUND_MODAL_STYLES_,
    StyledDescription,
    StyledModalContent,
    StyledModalFooter,
    StyledTitle,
} from "./styles";

type LeadGenNotFoundModalProps = {
    isOpen: boolean;
    onOpen: (isOpen: boolean) => void;
};

const LeadGenNotFoundModal: FC<LeadGenNotFoundModalProps> = ({ isOpen, onOpen }) => {
    const translate = useTranslation();

    return (
        <ProModal
            isOpen={isOpen}
            showCloseIcon={false}
            customStyles={CUSTOM_NOT_FOUND_MODAL_STYLES_}
        >
            <div>
                <StyledModalContent>
                    <StyledTitle>{translate("si.components.not_found_lead_gen_modal.title")}</StyledTitle>
                    <StyledDescription>
                        {translate("si.components.not_found_lead_gen_modal.subtitle")}
                    </StyledDescription>
                </StyledModalContent>
                <StyledModalFooter>
                    <Button
                        type="flat"
                        onClick={() => onOpen(false)}
                    >
                        {translate("si.components.not_found_lead_gen_modal.button")}
                    </Button>
                </StyledModalFooter>
            </div>
        </ProModal>
    );
};

export default LeadGenNotFoundModal;
